import {toast} from 'react-toastify';
import {t} from '@lingui/core/macro';
import {isDev} from 'shared/lib/evironment';
import IApiViolation from 'shared/api/model/IApiViolation';

type apiErrorType = {
    message: string,
    response: responseDataType
};

type responseDataType = {
    data: {
        violations?: IApiViolation[],
        detail?: string,
        message?: string,
    }
};

export interface IApiViolationsError extends Error {
    violations?: IApiViolation[],
}


// eslint-disable-next-line max-len
export const apiErrorHandler = async(error: apiErrorType, errorMessage: string, silent: boolean, status: number|null|undefined) => {
    // eslint-disable-next-line max-len
    const defaultErrorMessage = t`На сервере произошла ошибка, мы уже знаем об этом и работаем над исправлением. Пожалуйста, попробуйте повторить действие позднее или свяжитесь с нашей службой технической поддержки.`;
    // eslint-disable-next-line no-console
    isDev() && console.error(error.response.data);
    const response = error.response;
    let messages = [defaultErrorMessage];
    if (response?.data?.violations) {
        messages = response.data.violations
            .map((violation) => violation.message);
    } else if (response?.data?.detail) {
        messages = [response.data.detail];
    } else if (response?.data?.message) {
        messages = [response.data.message];
    } else if (errorMessage) {
        messages = [errorMessage || defaultErrorMessage];
    }

    const joinedMessages = messages.join('\n');

    if (!silent) {
        toast.warning(
            status !== null && status !== undefined && status >= 500 ?
                defaultErrorMessage : joinedMessages,
        );
    }

    const rejection: IApiViolationsError = new Error(joinedMessages);
    if (response?.data?.violations) {
        rejection.violations = response.data.violations;
    }

    return Promise.reject(rejection);
};